import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileUploadSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.25 5.3125V0H1.4375C0.917969 0 0.5 0.417969 0.5 0.9375V19.0625C0.5 19.582 0.917969 20 1.4375 20H14.5625C15.082 20 15.5 19.582 15.5 19.0625V6.25H10.1875C9.67188 6.25 9.25 5.82812 9.25 5.3125ZM11.7961 13.7504H9.25V16.8754C9.25 17.2207 8.97031 17.5004 8.625 17.5004H7.375C7.02969 17.5004 6.75 17.2207 6.75 16.8754V13.7504H4.20391C3.64609 13.7504 3.36758 13.075 3.76367 12.6816L7.53008 8.94336C7.78984 8.68516 8.20937 8.68516 8.46914 8.94336L12.2355 12.6816C12.632 13.075 12.3539 13.7504 11.7961 13.7504ZM15.2266 4.10156L11.4023 0.273438C11.2266 0.0976562 10.9883 0 10.7383 0H10.5V5H15.5V4.76172C15.5 4.51562 15.4023 4.27734 15.2266 4.10156Z",
		fill: "currentColor"
	})
});
export default SvgFileUploadSolid;
